import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// import { FileSelectDirective } from 'ng2-file-upload';
import { FileUploadModule } from 'ng2-file-upload';
import { Ng2InputMaskModule } from './modules/ng2-input-mask.module';
import { PaginationModule } from 'ng2-bs-pagination'; // shared ??

// SHARED
import { SharedModule } from '../shared/shared.module';

// ADMIN
import { AdminAppComponent } from './admin-app.component';
import { AdminRootComponent } from './admin-root.component';
import { AdminRoutingModule } from './admin-routing.module';
import { AdminMenuComponent } from './admin-menu.component';
import { AdminHeaderComponent } from './admin-header.component';
import { AdminFooterComponent } from './admin-footer.component';
import { AdminLoginComponent } from './admin-login.component';
import { AdminSearchFacetsComponent } from './admin-search-facets.component';
import { SearchResultsComponent } from './search-results.component';
import { ContentPageEditComponent } from './content-page-edit.component';
import { ContentPagesComponent } from './content-pages.component';
import { ContentRecordEditComponent } from './content-record-edit.component';
import { ContentRecordsComponent } from './content-records.component';
import { ContentSpecialEditComponent } from './content-special-edit.component';
import { ContentSpecialsComponent } from './content-specials.component';
import { ContentWritingEditComponent } from './content-writing-edit.component';
import { ContentWritingsComponent } from './content-writings.component';
import { ContentMessagesComponent } from './content-messages.component';
import { ContentMessageEditComponent } from './content-message-edit.component';
import { HtmlEditorComponent } from './html-editor.component';
import { ImageUploadComponent } from './image-upload.component';

const MODULES = [
  // Do NOT include UniversalModule, HttpModule, or JsonpModule here! 
  CommonModule,
  RouterModule,
  FormsModule,
  ReactiveFormsModule,
  Ng2InputMaskModule,
  FileUploadModule,
  PaginationModule,
  SharedModule, 
  AdminRoutingModule
];

const PIPES = [
  // put pipes here

];

const COMPONENTS = [
  // put shared components here
  // FileSelectDirective,
  AdminAppComponent,
  AdminRootComponent,
  AdminMenuComponent,
  AdminHeaderComponent,
  AdminFooterComponent,
  AdminLoginComponent,
  AdminSearchFacetsComponent,
  SearchResultsComponent,
  ContentPageEditComponent,
  ContentPagesComponent,
  ContentRecordEditComponent,
  ContentRecordsComponent,
  ContentSpecialEditComponent,
  ContentSpecialsComponent,
  ContentWritingEditComponent,
  ContentWritingsComponent,
  ContentMessagesComponent,
  ContentMessageEditComponent,
  HtmlEditorComponent,
  ImageUploadComponent
];

const PROVIDERS = [
]

@NgModule({
  imports: [
    ...MODULES
  ],
  declarations: [
    ...PIPES,
    ...COMPONENTS
  ],
  exports: [
    ...MODULES,
    ...PIPES,
    ...COMPONENTS
  ]
})
export class AdminModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: AdminModule,
      providers: [
        ...PROVIDERS
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/admin.module.ts